if (!customElements.get('dynamic-total-price')) {
  customElements.define(
    'dynamic-total-price',
    class DynamicTotalPrice extends HTMLElement {
      constructor() {
        super();
        this.amountEl = this.querySelector('[data-dynamic-total-amount]');
        this.sectionId = this.dataset.sectionId;
        this.unitPrice = parseInt(this.dataset.unitPrice, 10) || 0;
        this.currency = this.dataset.currency || 'JPY';
        this.locale = this.dataset.locale || 'ja-JP';

        this.onQtyChange = this.onQtyChange.bind(this);
        this.initFormatter();
      }

      initFormatter() {
        const initialText = (this.amountEl && (this.amountEl.dataset.initialText || this.amountEl.textContent) || '').trim();
        const match = initialText.match(/^(\D*?)([\d.,]+)(\D*)$/);

        if (match) {
          this.prefix = match[1] || '';
          this.suffix = match[3] || '';

          const numberStr = match[2];
          const lastDot = numberStr.lastIndexOf('.');
          this.fractionDigits = lastDot === -1 ? 0 : numberStr.length - lastDot - 1;
        } else {
          this.prefix = '';
          this.suffix = '';
          this.fractionDigits = this.currency === 'JPY' ? 0 : 2;
        }

        this.subunitDivisor = Math.pow(10, this.fractionDigits);

        try {
          this.numberFormatter = new Intl.NumberFormat(this.locale, {
            minimumFractionDigits: this.fractionDigits,
            maximumFractionDigits: this.fractionDigits,
          });
        } catch (e) {
          this.numberFormatter = new Intl.NumberFormat('en-US', {
            minimumFractionDigits: this.fractionDigits,
            maximumFractionDigits: this.fractionDigits,
          });
        }
      }

      connectedCallback() {
        this.bindQuantityInput();

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            if (!event || !event.data) return;
            if (event.data.sectionId && event.data.sectionId !== this.sectionId) return;

            const variant = event.data.variant;
            this.unitPrice = variant && variant.price != null ? parseInt(variant.price, 10) || 0 : 0;

            this.bindQuantityInput();
            this.render();
          });
        }

        this.render();
      }

      disconnectedCallback() {
        this.unbindQuantityInput();
        if (this.variantChangeUnsubscriber) this.variantChangeUnsubscriber();
      }

      bindQuantityInput() {
        this.unbindQuantityInput();
        this.qtyInput = document.getElementById(`Quantity-${this.sectionId}`);
        if (this.qtyInput) {
          this.qtyInput.addEventListener('change', this.onQtyChange);
          this.qtyInput.addEventListener('input', this.onQtyChange);
        }
      }

      unbindQuantityInput() {
        if (this.qtyInput) {
          this.qtyInput.removeEventListener('change', this.onQtyChange);
          this.qtyInput.removeEventListener('input', this.onQtyChange);
          this.qtyInput = null;
        }
      }

      onQtyChange() {
        this.render();
      }

      getQuantity() {
        if (!this.qtyInput) return 1;
        const value = parseInt(this.qtyInput.value, 10);
        return Number.isFinite(value) && value > 0 ? value : 1;
      }

      render() {
        if (!this.amountEl) return;
        const totalSubunits = this.unitPrice * this.getQuantity();
        const displayValue = totalSubunits / this.subunitDivisor;
        const formattedNumber = this.numberFormatter.format(displayValue);
        this.amountEl.textContent = `${this.prefix}${formattedNumber}${this.suffix}`;
      }
    }
  );
}
